import React, { createContext, useState } from "react";

const SessionContext = createContext();

const SessionProvider = ({ children }) => {
  const [sessionActive, setSessionActive] = useState(false);

  return (
    <SessionContext.Provider value={{ sessionActive, setSessionActive }}>
      {children}
    </SessionContext.Provider>
  );
};

export { SessionContext, SessionProvider };
